module.exports = __webpack_public_path__ + "static/img/img@2x.7befef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img@2x.png
// module id = 598
// module chunks = 1